__turbopack_context__.v({
  "Root": "qWCIeG_Root",
  "Root--ArticlePage": "qWCIeG_Root--ArticlePage",
  "Root--AutoHeight": "qWCIeG_Root--AutoHeight",
  "Root--ConnectionsPage": "qWCIeG_Root--ConnectionsPage",
  "Root--Grey": "qWCIeG_Root--Grey",
  "Root--NetworkTab": "qWCIeG_Root--NetworkTab",
  "Root--NoPaddingRight": "qWCIeG_Root--NoPaddingRight",
  "Root--RelatedCompanies": "qWCIeG_Root--RelatedCompanies",
  "Root--White": "qWCIeG_Root--White",
  "Title": "qWCIeG_Title",
  "skeleton-loading": "qWCIeG_skeleton-loading",
});
